export enum CoreTokenType {
  READWRITE = 'readwrite',
  READONLY = 'readonly',
  SENSOR = 'sensor',
}

// Token data returned by GET /v2/tokens
export type CoreToken = {
  key: string;
  name: string;
  description: string | null;
  token_type: CoreTokenType;
};
